(function (global) {
  'use strict';

  var FETCH_MS = 8000;

  function el(id) {
    return document.getElementById(id);
  }

  function escapeAttr(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function cssEscape(s) {
    if (global.CSS && CSS.escape) return CSS.escape(s);
    return String(s || '').replace(/"/g, '\\"');
  }

  function optValue(opt) {
    return typeof opt === 'string' ? opt : (opt && (opt.value || opt.label)) || '';
  }

  function optLabel(opt) {
    return typeof opt === 'string' ? opt : (opt && (opt.label || opt.value)) || '';
  }

  function emptyAnswers(questions) {
    var init = {};
    (questions || []).forEach(function (q) {
      init[q.id] = q.type === 'multi_choice' ? [] : '';
    });
    return init;
  }

  function fetchWithTimeout(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, FETCH_MS);
    var opts = Object.assign({}, options || {}, { signal: controller.signal });
    return fetch(url, opts).finally(function () {
      clearTimeout(timer);
    });
  }

  function init(sectionId) {
    var root = el('TypMarketingPreview-' + sectionId);
    if (!root || root.getAttribute('data-bound') === '1') return;
    root.setAttribute('data-bound', '1');

    var state = {
      apiKey: String(root.getAttribute('data-api-key') || '').trim(),
      baseUrl: String(root.getAttribute('data-base-url') || '')
        .trim()
        .replace(/\/$/, ''),
      questions: [],
      answers: {},
      blurb: '',
      complete: false,
      saving: false,
    };

    var ids = {
      email: 'TypMktEmail-' + sectionId,
      orderId: 'TypMktOrder-' + sectionId,
      locale: 'TypMktLocale-' + sectionId,
      btnLoad: 'TypMktLoad-' + sectionId,
      status: 'TypMktStatus-' + sectionId,
      body: 'TypMktBody-' + sectionId,
      debugMeta: 'TypMktDebugMeta-' + sectionId,
      debugOut: 'TypMktDebugOut-' + sectionId,
    };

    function setStatus(msg, kind) {
      var node = el(ids.status);
      if (!node) return;
      node.textContent = msg || '';
      node.className =
        'typ-mkt-preview__status' +
        (kind === 'err' ? ' typ-mkt-preview__status--err' : kind === 'ok' ? ' typ-mkt-preview__status--ok' : '');
    }

    function setDebug(meta, payload) {
      var metaEl = el(ids.debugMeta);
      var outEl = el(ids.debugOut);
      if (metaEl) metaEl.textContent = meta || '';
      if (outEl) {
        outEl.textContent =
          typeof payload === 'string' ? payload : JSON.stringify(payload, null, 2);
      }
    }

    function apiGetForm(params) {
      var url = new URL('/api/public/marketing-typ/form', state.baseUrl + '/');
      Object.keys(params || {}).forEach(function (k) {
        var v = params[k];
        if (v != null && String(v).trim() !== '') url.searchParams.set(k, String(v));
      });
      var full = url.toString();
      return fetchWithTimeout(full, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-Gtmlogger-Typ-Key': state.apiKey,
        },
      }).then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { http: r.status, okHttp: r.ok, data: data, url: full };
          });
      });
    }

    function apiPostAnswers(body) {
      var full = state.baseUrl + '/api/public/marketing-typ/answers';
      return fetchWithTimeout(full, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Gtmlogger-Typ-Key': state.apiKey,
        },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { http: r.status, okHttp: r.ok, data: data, url: full };
          });
      });
    }

    function applyForm(data) {
      state.blurb = data.blurb || '';
      state.questions = Array.isArray(data.questions) ? data.questions : [];
      state.complete = !!data.complete;
      state.answers = emptyAnswers(state.questions);
      renderPreview();
    }

    function renderPreview(extra) {
      var body = el(ids.body);
      if (!body) return;
      var hint = (extra && extra.hint) || '';
      var doneMsg = (extra && extra.doneMsg) || '';
      var q = state.questions[0];
      var isLast = state.questions.length <= 1;

      if (state.complete || !state.questions.length) {
        var msg =
          doneMsg ||
          state.blurb ||
          'Geen open vragen om te tonen (profiel compleet of klant zonder open vragen).';
        body.innerHTML = '<p class="typ-mkt-preview__done"></p>';
        body.querySelector('.typ-mkt-preview__done').textContent = msg;
        return;
      }

      var html = '';
      if (state.blurb) html += '<p class="typ-mkt-preview__blurb"></p>';
      html += '<div class="typ-mkt-preview__q" data-qid="' + escapeAttr(q.id) + '">';
      html += '<p class="typ-mkt-preview__q-label"></p>';
      if (q.type === 'multi_choice') {
        (q.options || []).forEach(function (opt) {
          var v = optValue(opt);
          html +=
            '<label class="typ-mkt-preview__opt"><input type="checkbox" data-qid="' +
            escapeAttr(q.id) +
            '" value="' +
            escapeAttr(v) +
            '" /><span></span></label>';
        });
      } else if (q.type === 'text') {
        html +=
          '<input class="typ-mkt-preview__text" type="text" data-qid="' +
          escapeAttr(q.id) +
          '" />';
      } else {
        html +=
          '<select class="typ-mkt-preview__select" data-qid="' +
          escapeAttr(q.id) +
          '"><option value="">Kies…</option>';
        (q.options || []).forEach(function (opt) {
          html += '<option value="' + escapeAttr(optValue(opt)) + '"></option>';
        });
        html += '</select>';
      }
      html += '</div>';
      html +=
        '<div class="typ-mkt-preview__actions"><button type="button" class="typ-mkt-preview__btn typ-mkt-preview__btn--primary" data-typ-submit="1">' +
        (isLast ? 'Klaar' : 'Volgende') +
        '</button></div>';
      if (hint) html += '<p class="typ-mkt-preview__hint" data-typ-hint="1"></p>';
      body.innerHTML = html;

      if (state.blurb) {
        var blurbEl = body.querySelector('.typ-mkt-preview__blurb');
        if (blurbEl) blurbEl.textContent = state.blurb;
      }
      var block = body.querySelector('.typ-mkt-preview__q[data-qid="' + cssEscape(q.id) + '"]');
      if (block) {
        var labelEl = block.querySelector('.typ-mkt-preview__q-label');
        if (labelEl) labelEl.textContent = q.label || q.id;
        if (q.type === 'multi_choice') {
          (q.options || []).forEach(function (opt, i) {
            var span = block.querySelectorAll('.typ-mkt-preview__opt span')[i];
            if (span) span.textContent = optLabel(opt);
          });
        } else if (q.type !== 'text') {
          (q.options || []).forEach(function (opt, i) {
            var option = block.querySelectorAll('option')[i + 1];
            if (option) option.textContent = optLabel(opt);
          });
        }
      }
      if (hint) {
        var h = body.querySelector('[data-typ-hint="1"]');
        if (h) h.textContent = hint;
      }
      var btn = body.querySelector('[data-typ-submit="1"]');
      if (btn) {
        btn.disabled = !!state.saving;
        btn.textContent = state.saving ? 'Opslaan…' : isLast ? 'Klaar' : 'Volgende';
        btn.addEventListener('click', onSubmit);
      }
      body.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var qid = cb.getAttribute('data-qid');
          var selected = [];
          body
            .querySelectorAll('input[type="checkbox"][data-qid="' + cssEscape(qid) + '"]')
            .forEach(function (node) {
              if (node.checked) selected.push(node.value);
            });
          state.answers[qid] = selected;
        });
      });
      body.querySelectorAll('.typ-mkt-preview__select, .typ-mkt-preview__text').forEach(function (node) {
        node.addEventListener('change', syncField);
        node.addEventListener('input', syncField);
      });
    }

    function syncField(ev) {
      var node = ev.target;
      var qid = node.getAttribute('data-qid');
      if (!qid) return;
      state.answers[qid] = node.value;
    }

    function collectCurrentAnswer() {
      var q = state.questions[0];
      if (!q) return { error: 'Geen vraag.' };
      var payload = {};
      var v = state.answers[q.id];
      if (q.type === 'multi_choice') {
        if (!Array.isArray(v) || !v.length) {
          return { error: 'Beantwoord de vraag om door te gaan.' };
        }
        payload[q.id] = v;
      } else {
        var t = String(v || '').trim();
        if (!t) return { error: 'Beantwoord de vraag om door te gaan.' };
        payload[q.id] = t;
      }
      return { answers: payload };
    }

    function onLoad() {
      if (!state.baseUrl || !state.apiKey) {
        setStatus('Vul base URL en TYP API-sleutel in via de theme-editor', 'err');
        return;
      }
      var email = String(el(ids.email).value || '').trim();
      var orderId = String(el(ids.orderId).value || '').trim();
      var locale = String(el(ids.locale).value || 'nl').trim();
      if (!email && !orderId) {
        setStatus('Vul e-mail of order-id in', 'err');
        return;
      }
      if (email && email.indexOf('@') < 0) {
        setStatus('Ongeldig e-mailadres', 'err');
        return;
      }
      var btn = el(ids.btnLoad);
      btn.disabled = true;
      setStatus('Laden…');
      apiGetForm({ email: email, order_id: orderId, locale: locale })
        .then(function (res) {
          setDebug('GET ' + res.url + ' · HTTP ' + res.http + ' · base ' + state.baseUrl, res.data);
          if (!res.okHttp || res.data.ok === false) {
            setStatus('Laden mislukt: ' + (res.data.error || 'HTTP ' + res.http), 'err');
            el(ids.body).innerHTML = '<p class="typ-mkt-preview__muted">Geen formulier geladen.</p>';
            return;
          }
          applyForm(res.data);
          setStatus(
            'OK · ' +
              state.questions.length +
              ' vraag/vragen' +
              (state.complete ? ' · profiel compleet' : ''),
            'ok'
          );
        })
        .catch(function (err) {
          var msg = err && err.name === 'AbortError' ? 'Timeout' : err.message || String(err);
          setStatus('Laden mislukt: ' + msg, 'err');
          setDebug('Fout', msg);
        })
        .finally(function () {
          btn.disabled = false;
        });
    }

    function onSubmit() {
      var collected = collectCurrentAnswer();
      if (collected.error) {
        renderPreview({ hint: collected.error });
        return;
      }
      state.saving = true;
      renderPreview();
      setStatus('Opslaan…');
      apiPostAnswers({
        order_id: String(el(ids.orderId).value || '').trim(),
        email: String(el(ids.email).value || '').trim(),
        answers: collected.answers,
        locale: String(el(ids.locale).value || 'nl').trim(),
        source: 'typ-preview-shopify',
      })
        .then(function (res) {
          setDebug('POST ' + res.url + ' · HTTP ' + res.http, res.data);
          state.saving = false;
          if (!res.okHttp || res.data.ok === false) {
            setStatus('Opslaan mislukt: ' + (res.data.error || 'HTTP ' + res.http), 'err');
            renderPreview({ hint: 'Opslaan lukte niet.' });
            return;
          }
          var form = res.data.form || {};
          applyForm(form);
          if (form.complete || !(form.questions || []).length) {
            setStatus('Opgeslagen · klaar', 'ok');
            renderPreview({ doneMsg: form.blurb || 'Bedankt!' });
          } else {
            setStatus('Opgeslagen — volgende vraag', 'ok');
            renderPreview();
          }
        })
        .catch(function (err) {
          state.saving = false;
          var msg = err && err.name === 'AbortError' ? 'Timeout' : err.message || String(err);
          setStatus('Opslaan mislukt: ' + msg, 'err');
          renderPreview({ hint: msg });
        });
    }

    el(ids.btnLoad).addEventListener('click', onLoad);
    el(ids.email).addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        onLoad();
      }
    });
    el(ids.orderId).addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        onLoad();
      }
    });

    try {
      var q = new URLSearchParams(global.location.search);
      if (q.get('email')) el(ids.email).value = q.get('email');
      if (q.get('order_id')) el(ids.orderId).value = q.get('order_id');
      if (q.get('locale')) el(ids.locale).value = q.get('locale');
      if ((q.get('email') || q.get('order_id')) && state.apiKey) onLoad();
    } catch (_) {}
  }

  global.TypMarketingPreview = { init: init };
})(typeof window !== 'undefined' ? window : this);
